import {DetailsValues, normalizedValue, selectionID} from '../state/values';

/** Converts only changed detail fields to the existing GraphQL patch shape; route fields are excluded. */
export function detailsPatch(values: DetailsValues): DetailsValues {
    const patch: DetailsValues = {};
    for (const field of Object.keys(values)) {
        if (['aircraftID', 'contractID', 'pilotID', 'copilotID'].includes(field)) {
            patch[field] = selectionID(values[field]);
        } else if (field === 'estDepartureTime') {
            const time = normalizedValue(field, values[field]);
            patch[field] = time ? `${time}:00` : '';
        } else if (['desig', 'scheduledFlightDate', 'setWeatherDelay'].includes(field)) {
            patch[field] = normalizedValue(field, values[field]);
        }
    }
    return patch;
}
